import { Equals, Expect } from "@/types"
import { createAssertFn } from "@/utils/validator"
import { CartDetail } from "src/types"
import * as v from "valibot"

const BundledDiscountSchema = v.object({
  items: v.pipe(
    v.array(
      v.object({
        productId: v.pipe(v.string(), v.minLength(1)),
        variantId: v.pipe(v.string(), v.minLength(1)),
        quantity: v.optional(v.pipe(v.number(), v.minValue(0)))
      })
    ),
    v.minLength(1)
  ),
  discount: v.object({
    type: v.picklist(["percent", "dollar"]),
    value: v.pipe(v.number(), v.minValue(0))
  }),
  hash: v.optional(v.string()),
  bundleProducts: v.union([v.array(v.string()), v.array(v.pipe(v.number(), v.integer()))])
})

export const assertValid = createAssertFn("BundleDiscount", BundledDiscountSchema)

export type tests = [
  // expect that CartDetail and schema input are equal
  Expect<Equals<CartDetail, v.InferInput<typeof BundledDiscountSchema>>>
]
